module.exports = __webpack_public_path__ + "static/appstore-deu-light-5cd3673d44cc491c8a92479ea1e27e4a.svg";